import React from 'react';
import Button from '../elements/Button';

const BotSummaryCard: React.FC<{ count: number; onManageClick?: () => void }> = ({
  count,
  onManageClick,
}) => {
  const PURPLE = 'var(--primary)';

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minHeight: '200px',
        minWidth: '200px',
        backgroundColor: 'var(--tint)',
        border: `2px solid ${PURPLE}`,
        borderRadius: '16px',
        padding: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Montserrat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      }}
    >
      <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ fontSize: 'clamp(12px, 1.2vw, 16px)', color: '#555', marginBottom: '4px' }}>
          Total Bots
        </div>
        <div
          style={{
            fontSize: 'clamp(36px, 5vw, 64px)',
            fontWeight: 800,
            color: PURPLE,
            lineHeight: 1.2,
          }}
        >
          {count}
        </div>
        <div
          style={{
            marginTop: '8px',
            fontSize: 'clamp(12px, 1vw, 14px)',
            color: '#666',
            padding: '0 12px',
            marginBottom: '10px',
          }}
        >
          {count === 1
            ? 'You have 1 assistant helping you connect with users.'
            : `You have ${count} active assistants`}
        </div>
      </div>

      <Button
        label="Manage Assistants"
        width="200px"
        height="50px"
        onClick={onManageClick}
      />
    </div>
  );
};

export default BotSummaryCard;
